const path = process.env.BASE_URL;

//个人版的视频目录
const personalList = [
    {
        label: '个人版快速入门',
        src: '/个人版视频操作教程.mp4'
    },
    {
        label: '控制中心工具栏',
        children: [
            {
                label: '题目信息',
                children: [
                    {
                        label: '题型的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题型的管理---自定义添加、修改、删除、排序.mp4'
                    },
                    {
                        label: '题目适用范围的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题目适用范围的管理---自定义添加、修改、删除、排序.mp4'
                    },
                    {
                        label: '题目难度的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题目难度的管理---自定义添加、修改、删除、排序.mp4'
                    },
                    {
                        label: '题目标签的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题目标签的管理---自定义添加、修改、删除、排序.mp4'
                    },
                ]
            },
            {
                label: '新建题库',
                src: '/控制中心工具栏/新建题库.mp4'
            },
            {
                label: '题库的还原（从备份）',
                src: '/控制中心工具栏/题库的还原（从备份）.mp4'
            },
            {
                label: '题库的备份',
                src: '/控制中心工具栏/题库的备份.mp4'
            },
            {
                label: '控制中心工具栏--总览',
                src: '/控制中心工具栏/控制中心工具栏--总览.mp4'
            },
            {
                label: '导入题库',
                src: '/控制中心工具栏/导入题库.mp4'
            },
            {
                label: '导出题库',
                src: '/控制中心工具栏/导出题库.mp4'
            },
        ]
    },
    {
        label: '快速批量添加题目',
        children: [
            {
                label: '题目的快速批量添加：模板1的使用',
                children: [
                    {
                        label: '001、一键智能处理',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/001、一键智能处理.mp4'
                    },
                    {
                        label: '00引言、模板1的格式说明',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/00引言、模板1的格式说明.mp4'
                    },
                    {
                        label: '00引言、模板2的格式说明',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/00引言、模板2的格式说明.mp4'
                    },
                    {
                        label: '1、加载题源文档',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/1、加载题源文档.mp4'
                    },
                    {
                        label: '2、题型的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/2、题型的识别.mp4'
                    },
                    {
                        label: '3、题目的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/3、题目的识别.mp4'
                    },
                    {
                        label: '4、答案的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/4、答案的识别.mp4'
                    },
                    {
                        label: '5、题目分割显示，调整图片位置',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/5、题目分割显示，调整图片位置.mp4'
                    },
                    {
                        label: '6-1、设定入库标记（最简）',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/6-1、设定入库标记（最简）.mp4'
                    },
                    {
                        label: '6-2、设定入库标记（专业）',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/6-2、设定入库标记（专业）.mp4'
                    },
                    {
                        label: '7-01、批量入库（快速）',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/7-01、批量入库（快速）.mp4'
                    },
                ]
            },
            {
                label: '题目的快速批量添加：模板2的使用',
                children: [
                    {
                        label: '00引言、模板2的格式说明',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/00引言、模板2的格式说明.mp4'
                    },
                    {
                        label: '01、一键智能处理--模板2',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/01、一键智能处理--模板2.mp4'
                    },
                    {
                        label: '1、加载题源文档',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/1、加载题源文档.mp4'
                    },
                    {
                        label: '4、答案的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/4、答案的识别.mp4'
                    },
                    {
                        label: '5、匹配检查--检查题目和答案是否匹配',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/5、匹配检查--检查题目和答案是否匹配.mp4'
                    },
                    {
                        label: '6、答案题后--把集中于文档末尾的答案移动到相应题目之后',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/6、答案题后--把集中于文档末尾的答案移动到相应题目之后.mp4'
                    },             
                ]
            },
            {
                label: '题目的快速批量添加：模板3的使用',
                children: [
                    {
                        label: '4、答案的识别：括号内的答案',
                        src: '/快速批量添加题目/题目的快速批量添加：模板3的使用/4、答案的识别：括号内的答案.mp4'
                    },
                    {
                        label: '4、答案的识别：横线上的答案',
                        src: '/快速批量添加题目/题目的快速批量添加：模板3的使用/4、答案的识别：横线上的答案.mp4'
                    },
                    {
                        label: '4、答案的识别：按标记识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板3的使用/4、答案的识别：按标记识别.mp4'
                    },
                ]
            },
            {
                label: '题目的快速批量添加：工具栏的使用',
                children: [
                    {
                        label: '转文字--表格一键转文字',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/转文字--表格一键转文字.mp4'
                    },
                    {
                        label: '一行一题--一键分题',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/一行一题--一键分题.mp4'
                    },
                    {
                        label: '图片转嵌入式（加载题源文档时）',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/图片转嵌入式（加载题源文档时）.mp4'
                    },
                    {
                        label: '图片转嵌入式（工具栏）',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/图片转嵌入式（工具栏）.mp4'
                    },
                    {
                        label: '清除格式--清除选中内容的所有格式',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/清除格式--清除选中内容的所有格式.mp4'
                    },
                    {
                        label: '空行--请除选中区域的全部空行',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/空行--请除选中区域的全部空行.mp4'
                    },
                    {
                        label: '格（多选）--紧凑式多选题的一键格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（多选）--紧凑式多选题的一键格式化.mp4'
                    },
                    {
                        label: '格（单选）、格（多选）--表格内答案的一键格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（单选）、格（多选）--表格内答案的一键格式化.mp4'
                    },
                    {
                        label: '格（单选）、格（多选）--表格内答案的快速格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（单选）、格（多选）--表格内答案的快速格式化.mp4'
                    },
                    {
                        label: '格（单选）--紧凑式单选题的一键格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（单选）--紧凑式单选题的一键格式化.mp4'
                    },
                ]
            },
            {
                label: '复合题的批量入库---英语、语文、其它所有科目的复合题题型',
                src: '/快速批量添加题目/复合题的批量入库---英语、语文、其它所有科目的复合题题型.mp4'
            },
        ]
    },
    {
        label: '视频教程：题目的浏览',
        children: [
            {
                label: '题目移到回收站与删除',
                children: [
                    {
                        label: '题目移到回收站',
                        src: '/视频教程：题目的浏览/题目移到回收站与删除/题目移到回收站.mp4'
                    },
                    {
                        label: '从回收站恢复题目',
                        src: '/视频教程：题目的浏览/题目移到回收站与删除/从回收站恢复题目.mp4'
                    },
                    {
                        label: '彻底删除题目',
                        src: '/视频教程：题目的浏览/题目移到回收站与删除/彻底删除题目.mp4'
                    },
                ]
            },
            // {
            //     label: '题目的快速筛选'
            // },
            {
                label: '试题篮的操作',
                children: [
                    {
                        label: '移出试题篮',
                        src: '/视频教程：题目的浏览/试题篮的操作/移出试题篮.mp4'
                    },
                    {
                        label: '添加到试题篮',
                        src: '/视频教程：题目的浏览/试题篮的操作/添加到试题篮.mp4'
                    },
                    {
                        label: '清空试题篮',
                        src: '/视频教程：题目的浏览/试题篮的操作/清空试题篮.mp4'
                    },
                ]
            },
            {
                label: '快速浏览',
                children: [
                    {
                        label: '题目的浏览：显示（隐藏）题目信息',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：显示（隐藏）题目信息.mp4'
                    },
                    {
                        label: '题目的浏览：显示（隐藏）答案区域',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：显示（隐藏）答案区域.mp4'
                    },
                    {
                        label: '题目的浏览：设定每页显示题数',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：设定每页显示题数.mp4'
                    },
                    {
                        label: '题目的浏览：翻页',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：翻页.mp4'
                    },
                    {
                        label: '题目的浏览（快速）',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览（快速）.mp4'
                    },
                ]
            },
            {
                label: '选中题目的3种方法',
                src: '/视频教程：题目的浏览/选中题目的3种方法.mp4'
            },
            {
                label: '题目的快速筛选',
                src: '/视频教程：题目的浏览/题目的快速筛选.mp4'
            },
            {
                label: '灵活的布局调整',
                src: '/视频教程：题目的浏览/灵活的布局调整.mp4'
            },
            {
                label: '快速搜索符合条件的题目',
                src: '/视频教程：题目的浏览/快速搜索符合条件的题目.mp4'
            },
            {
                label: '快速调整题目的章节（拖动）',
                src: '/视频教程：题目的浏览/快速调整题目的章节（拖动）.mp4'
            },
            {
                label: '快速、批量修改题目属性',
                src: '/视频教程：题目的浏览/快速、批量修改题目属性.mp4'
            },
            {
                label: '放大与缩小浏览内容',
                src: '/视频教程：题目的浏览/放大与缩小浏览内容.mp4'
            },
        ]
    },
    {
        label: '视频教程：目录的操作',
        children: [
            {
                label: '修改目录',
                children: [
                    {
                        label: '2-1、修改目录---方法1：使用工具栏按钮',
                        src: '/视频教程：目录的操作/修改目录/2-1、修改目录---方法1：使用工具栏按钮.mp4'
                    },
                    {
                        label: '2-2、修改目录---方法2：使用弹出菜单',
                        src: '/视频教程：目录的操作/修改目录/2-2、修改目录---方法2：使用弹出菜单.mp4'
                    },
                    {
                        label: '2-3、修改目录---方法3：使用快捷键（快速）',
                        src: '/视频教程：目录的操作/修改目录/2-3、修改目录---方法3：使用快捷键（快速）.mp4'
                    },
                ]
            },
            {
                label: '添加目录',
                children: [
                    {
                        label: '1-1、添加目录---方法1：使用工具栏按钮',
                        src: '/视频教程：目录的操作/添加目录/1-1、添加目录---方法1：使用工具栏按钮.mp4'
                    },
                    {
                        label: '1-2、添加目录---方法2：使用弹出菜单',
                        src: '/视频教程：目录的操作/添加目录/1-2、添加目录---方法2：使用弹出菜单.mp4'
                    },
                    {
                        label: '1-3、添加目录---方法3：使用快捷键（快速）',
                        src: '/视频教程：目录的操作/添加目录/1-3、添加目录---方法3：使用快捷键（快速）.mp4'
                    },
                ]
            },
            {
                label: '删除目录',
                children: [
                    {
                        label: '3-1、删除目录---方法1：使用工具栏按钮',
                        src: '/视频教程：目录的操作/删除目录/3-1、删除目录---方法1：使用工具栏按钮.mp4'
                    },
                    {
                        label: '3-2、删除目录---方法2：使用弹出菜单',
                        src: '/视频教程：目录的操作/删除目录/3-2、删除目录---方法2：使用弹出菜单.mp4'
                    },
                    {
                        label: '3-3、删除目录---方法3：使用快捷键（快速）',
                        src: '/视频教程：目录的操作/删除目录/3-3、删除目录---方法3：使用快捷键（快速）.mp4'
                    },
                ]
            },
            {
                label: '4、快速调整现有目录结构（拖拽）',
                src: '/视频教程：目录的操作/4、快速调整现有目录结构（拖拽）.mp4'
            },
            {
                label: '5、调整同级目录的相对顺序',
                src: '/视频教程：目录的操作/5、调整同级目录的相对顺序.mp4'
            },
            {
                label: '6、从Excel导入目录',
                src: '/视频教程：目录的操作/6、从Excel导入目录.mp4'
            },
            {
                label: '7、导出目录到Excel',
                src: '/视频教程：目录的操作/7、导出目录到Excel.mp4'
            },
        ]
    },
    {
        label: '应用中心',
        children: [
            {
                label: '智能组卷',
                children: [
                    {
                        label: '智能组卷',
                        src: '/应用中心/智能组卷/智能组卷.mp4'
                    },
                    {
                        label: '智能组卷---组卷方案的保存、应用和删除',
                        src: '/应用中心/智能组卷/智能组卷---组卷方案的保存、应用和删除.mp4'
                    }
                ]
            },
            {
                label: '试卷（库）设置',
                children: [
                    {
                        label: '从试题篮克隆到新试卷',
                        src: '/应用中心/试卷（库）设置/从试题篮克隆到新试卷.mp4'
                    },
                    {
                        label: '调整题目、题型的顺序，更换题目',
                        src: '/应用中心/试卷（库）设置/调整题目、题型的顺序，更换题目.mp4'
                    },
                    {
                        label: '快速设定试卷样式',
                        src: '/应用中心/试卷（库）设置/快速设定试卷样式.mp4'
                    },
                    {
                        label: '设置题目的分值',
                        src: '/应用中心/试卷（库）设置/设置题目的分值.mp4'
                    },
                    {
                        label: '填写试卷信息',
                        src: '/应用中心/试卷（库）设置/填写试卷信息.mp4'
                    },
                ]
            },
            {
                label: '生成试卷（Word）',
                children: [
                    {
                        label: '生成试卷（Word）--学生卷',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--学生卷.mp4'
                    },
                    {
                        label: '生成试卷（Word）--选择题选项快速对齐',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--选择题选项快速对齐.mp4'
                    },
                    {
                        label: '生成试卷（Word）--选择题括号快速对齐',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--选择题括号快速对齐.mp4'
                    },
                    {
                        label: '生成试卷（Word）--普通卷：更换样式',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--普通卷：更换样式.mp4'
                    },
                    {
                        label: '生成试卷（Word）--普通卷',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--普通卷.mp4'
                    },
                    {
                        label: '生成试卷（Word）--快速设置版式',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--快速设置版式.mp4'
                    },
                    {
                        label: '生成试卷（Word）--教师卷',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--教师卷.mp4'
                    },
                ]
            },
            {
                label: '导出到幻灯片',
                children: [
                    {
                        label: '导出到幻灯片',
                        src: '/应用中心/导出到幻灯片/导出到幻灯片.mp4'
                    },
                ]
            },
        ]
    },
];


//网络版的视频目录
const netList = [
    {
        label: '网络版快速入门',
        src: '/乐分享题库系统  网络版  入门教程.mp4'
    },
    {
        label: '控制中心工具栏',
        children: [
            {
                label: '题目信息',
                children: [
                    {
                        label: '题型的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题型的管理---自定义添加、修改、删除、排序.mp4'
                    },
                    {
                        label: '题目适用范围的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题目适用范围的管理---自定义添加、修改、删除、排序.mp4'
                    },
                    {
                        label: '题目难度的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题目难度的管理---自定义添加、修改、删除、排序.mp4'
                    },
                    {
                        label: '题目标签的管理---自定义添加、修改、删除、排序',
                        src: '/控制中心工具栏/题目信息/题目标签的管理---自定义添加、修改、删除、排序.mp4'
                    },
                ]
            },
            {
                label: '新建题库',
                src: '/控制中心工具栏/新建题库.mp4'
            },
            {
                label: '题库的还原（从备份）',
                src: '/控制中心工具栏/题库的还原（从备份）.mp4'
            },
            {
                label: '题库的备份',
                src: '/控制中心工具栏/题库的备份.mp4'
            },
            {
                label: '控制中心工具栏--总览',
                src: '/控制中心工具栏/控制中心工具栏--总览.mp4'
            },
            {
                label: '导入题库',
                src: '/控制中心工具栏/导入题库.mp4'
            },
            {
                label: '导出题库',
                src: '/控制中心工具栏/导出题库.mp4'
            },
        ]
    },
    {
        label: '快速批量添加题目',
        children: [
            {
                label: '题目的快速批量添加：模板1的使用',
                children: [
                    {
                        label: '001、一键智能处理',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/001、一键智能处理.mp4'
                    },
                    {
                        label: '00引言、模板1的格式说明',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/00引言、模板1的格式说明.mp4'
                    },
                    {
                        label: '00引言、模板2的格式说明',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/00引言、模板2的格式说明.mp4'
                    },
                    {
                        label: '1、加载题源文档',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/1、加载题源文档.mp4'
                    },
                    {
                        label: '2、题型的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/2、题型的识别.mp4'
                    },
                    {
                        label: '3、题目的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/3、题目的识别.mp4'
                    },
                    {
                        label: '4、答案的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/4、答案的识别.mp4'
                    },
                    {
                        label: '5、题目分割显示，调整图片位置',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/5、题目分割显示，调整图片位置.mp4'
                    },
                    {
                        label: '6-1、设定入库标记（最简）',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/6-1、设定入库标记（最简）.mp4'
                    },
                    {
                        label: '6-2、设定入库标记（专业）',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/6-2、设定入库标记（专业）.mp4'
                    },
                    {
                        label: '7-01、批量入库（快速）',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/7-01、批量入库（快速）.mp4'
                    },
                    {
                        label: '7-02、批量入库（专业）',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/7-02、批量入库（专业）.mp4'
                    },
                    {
                        label: '7-03、批量入库--入库前快速预览',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/7-03、批量入库--入库前快速预览.mp4'
                    },
                    {
                        label: '7-04、批量入库--入库前Word中实际效果预览',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/7-04、批量入库--入库前Word中实际效果预览.mp4'
                    },
                    {
                        label: '7-05、批量入库--入库前重题检查',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/7-05、批量入库--入库前重题检查.mp4'
                    },
                    {
                        label: '7-06、批量入库--开始入库',
                        src: '/快速批量添加题目/题目的快速批量添加：模板1的使用/7-06、批量入库--开始入库.mp4'
                    },
                ]
            },
            {
                label: '题目的快速批量添加：模板2的使用',
                children: [
                    {
                        label: '00引言、模板2的格式说明',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/00引言、模板2的格式说明.mp4'
                    },
                    {
                        label: '01、一键智能处理--模板2',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/01、一键智能处理--模板2.mp4'
                    },
                    {
                        label: '1、加载题源文档',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/1、加载题源文档.mp4'
                    },
                    {
                        label: '4、答案的识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/4、答案的识别.mp4'
                    },
                    {
                        label: '5、匹配检查--检查题目和答案是否匹配',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/5、匹配检查--检查题目和答案是否匹配.mp4'
                    },
                    {
                        label: '6、答案题后--把集中于文档末尾的答案移动到相应题目之后',
                        src: '/快速批量添加题目/题目的快速批量添加：模板2的使用/6、答案题后--把集中于文档末尾的答案移动到相应题目之后.mp4'
                    },             
                ]
            },
            {
                label: '题目的快速批量添加：模板3的使用',
                children: [
                    {
                        label: '4、答案的识别：括号内的答案',
                        src: '/快速批量添加题目/题目的快速批量添加：模板3的使用/4、答案的识别：括号内的答案.mp4'
                    },
                    {
                        label: '4、答案的识别：横线上的答案',
                        src: '/快速批量添加题目/题目的快速批量添加：模板3的使用/4、答案的识别：横线上的答案.mp4'
                    },
                    {
                        label: '4、答案的识别：按标记识别',
                        src: '/快速批量添加题目/题目的快速批量添加：模板3的使用/4、答案的识别：按标记识别.mp4'
                    },
                ]
            },
            {
                label: '题目的快速批量添加：工具栏的使用',
                children: [
                    {
                        label: '转文字--表格一键转文字',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/转文字--表格一键转文字.mp4'
                    },
                    {
                        label: '一行一题--一键分题',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/一行一题--一键分题.mp4'
                    },
                    {
                        label: '图片转嵌入式（加载题源文档时）',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/图片转嵌入式（加载题源文档时）.mp4'
                    },
                    {
                        label: '图片转嵌入式（工具栏）',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/图片转嵌入式（工具栏）.mp4'
                    },
                    {
                        label: '清除格式--清除选中内容的所有格式',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/清除格式--清除选中内容的所有格式.mp4'
                    },
                    {
                        label: '空行--请除选中区域的全部空行',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/空行--请除选中区域的全部空行.mp4'
                    },
                    {
                        label: '格（多选）--紧凑式多选题的一键格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（多选）--紧凑式多选题的一键格式化.mp4'
                    },
                    {
                        label: '格（单选）、格（多选）--表格内答案的一键格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（单选）、格（多选）--表格内答案的一键格式化.mp4'
                    },
                    {
                        label: '格（单选）、格（多选）--表格内答案的快速格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（单选）、格（多选）--表格内答案的快速格式化.mp4'
                    },
                    {
                        label: '格（单选）--紧凑式单选题的一键格式化',
                        src: '/快速批量添加题目/题目的快速批量添加：工具栏的使用/格（单选）--紧凑式单选题的一键格式化.mp4'
                    },
                ]
            },
            {
                label: '复合题的批量入库---英语、语文、其它所有科目的复合题题型',
                src: '/快速批量添加题目/复合题的批量入库---英语、语文、其它所有科目的复合题题型.mp4'
            },
        ]
    },
    {
        label: '视频教程：题目的浏览',
        children: [
            {
                label: '题目移到回收站与删除',
                children: [
                    {
                        label: '题目移到回收站',
                        src: '/视频教程：题目的浏览/题目移到回收站与删除/题目移到回收站.mp4'
                    },
                    {
                        label: '从回收站恢复题目',
                        src: '/视频教程：题目的浏览/题目移到回收站与删除/从回收站恢复题目.mp4'
                    },
                    {
                        label: '彻底删除题目',
                        src: '/视频教程：题目的浏览/题目移到回收站与删除/彻底删除题目.mp4'
                    },
                ]
            },
            // {
            //     label: '题目的快速筛选'
            // },
            {
                label: '试题篮的操作',
                children: [
                    {
                        label: '移出试题篮',
                        src: '/视频教程：题目的浏览/试题篮的操作/移出试题篮.mp4'
                    },
                    {
                        label: '添加到试题篮',
                        src: '/视频教程：题目的浏览/试题篮的操作/添加到试题篮.mp4'
                    },
                    {
                        label: '清空试题篮',
                        src: '/视频教程：题目的浏览/试题篮的操作/清空试题篮.mp4'
                    },
                ]
            },
            {
                label: '快速浏览',
                children: [
                    {
                        label: '题目的浏览：显示（隐藏）题目信息',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：显示（隐藏）题目信息.mp4'
                    },
                    {
                        label: '题目的浏览：显示（隐藏）答案区域',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：显示（隐藏）答案区域.mp4'
                    },
                    {
                        label: '题目的浏览：设定每页显示题数',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：设定每页显示题数.mp4'
                    },
                    {
                        label: '题目的浏览：翻页',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览：翻页.mp4'
                    },
                    {
                        label: '题目的浏览（快速）',
                        src: '/视频教程：题目的浏览/快速浏览/题目的浏览（快速）.mp4'
                    },
                ]
            },
            {
                label: '选中题目的3种方法',
                src: '/视频教程：题目的浏览/选中题目的3种方法.mp4'
            },
            {
                label: '题目的快速筛选',
                src: '/视频教程：题目的浏览/题目的快速筛选.mp4'
            },
            {
                label: '灵活的布局调整',
                src: '/视频教程：题目的浏览/灵活的布局调整.mp4'
            },
            {
                label: '快速搜索符合条件的题目',
                src: '/视频教程：题目的浏览/快速搜索符合条件的题目.mp4'
            },
            {
                label: '快速调整题目的章节（拖动）',
                src: '/视频教程：题目的浏览/快速调整题目的章节（拖动）.mp4'
            },
            {
                label: '快速、批量修改题目属性',
                src: '/视频教程：题目的浏览/快速、批量修改题目属性.mp4'
            },
            {
                label: '放大与缩小浏览内容',
                src: '/视频教程：题目的浏览/放大与缩小浏览内容.mp4'
            },
        ]
    },
    {
        label: '视频教程：目录的操作',
        children: [
            {
                label: '修改目录',
                children: [
                    {
                        label: '2-1、修改目录---方法1：使用工具栏按钮',
                        src: '/视频教程：目录的操作/修改目录/2-1、修改目录---方法1：使用工具栏按钮.mp4'
                    },
                    {
                        label: '2-2、修改目录---方法2：使用弹出菜单',
                        src: '/视频教程：目录的操作/修改目录/2-2、修改目录---方法2：使用弹出菜单.mp4'
                    },
                    {
                        label: '2-3、修改目录---方法3：使用快捷键（快速）',
                        src: '/视频教程：目录的操作/修改目录/2-3、修改目录---方法3：使用快捷键（快速）.mp4'
                    },
                ]
            },
            {
                label: '添加目录',
                children: [
                    {
                        label: '1-1、添加目录---方法1：使用工具栏按钮',
                        src: '/视频教程：目录的操作/添加目录/1-1、添加目录---方法1：使用工具栏按钮.mp4'
                    },
                    {
                        label: '1-2、添加目录---方法2：使用弹出菜单',
                        src: '/视频教程：目录的操作/添加目录/1-2、添加目录---方法2：使用弹出菜单.mp4'
                    },
                    {
                        label: '1-3、添加目录---方法3：使用快捷键（快速）',
                        src: '/视频教程：目录的操作/添加目录/1-3、添加目录---方法3：使用快捷键（快速）.mp4'
                    },
                ]
            },
            {
                label: '删除目录',
                children: [
                    {
                        label: '3-1、删除目录---方法1：使用工具栏按钮',
                        src: '/视频教程：目录的操作/删除目录/3-1、删除目录---方法1：使用工具栏按钮.mp4'
                    },
                    {
                        label: '3-2、删除目录---方法2：使用弹出菜单',
                        src: '/视频教程：目录的操作/删除目录/3-2、删除目录---方法2：使用弹出菜单.mp4'
                    },
                    {
                        label: '3-3、删除目录---方法3：使用快捷键（快速）',
                        src: '/视频教程：目录的操作/删除目录/3-3、删除目录---方法3：使用快捷键（快速）.mp4'
                    },
                ]
            },
            {
                label: '4、快速调整现有目录结构（拖拽）',
                src: '/视频教程：目录的操作/4、快速调整现有目录结构（拖拽）.mp4'
            },
            {
                label: '5、调整同级目录的相对顺序',
                src: '/视频教程：目录的操作/5、调整同级目录的相对顺序.mp4'
            },
            {
                label: '6、从Excel导入目录',
                src: '/视频教程：目录的操作/6、从Excel导入目录.mp4'
            },
            {
                label: '7、导出目录到Excel',
                src: '/视频教程：目录的操作/7、导出目录到Excel.mp4'
            },
        ]
    },
    {
        label: '应用中心',
        children: [
            {
                label: '智能组卷',
                children: [
                    {
                        label: '智能组卷',
                        src: '/应用中心/智能组卷/智能组卷.mp4'
                    },
                    {
                        label: '智能组卷---组卷方案的保存、应用和删除',
                        src: '/应用中心/智能组卷/智能组卷---组卷方案的保存、应用和删除.mp4'
                    }
                ]
            },
            {
                label: '试卷（库）设置',
                children: [
                    {
                        label: '从试题篮克隆到新试卷',
                        src: '/应用中心/试卷（库）设置/从试题篮克隆到新试卷.mp4'
                    },
                    {
                        label: '调整题目、题型的顺序，更换题目',
                        src: '/应用中心/试卷（库）设置/调整题目、题型的顺序，更换题目.mp4'
                    },
                    {
                        label: '发布考试',
                        src: '/应用中心/试卷（库）设置/发布考试.mp4'
                    },
                    {
                        label: '快速设定试卷样式',
                        src: '/应用中心/试卷（库）设置/快速设定试卷样式.mp4'
                    },
                    {
                        label: '设置题目的分值',
                        src: '/应用中心/试卷（库）设置/设置题目的分值.mp4'
                    },
                    {
                        label: '试卷的启用_停用',
                        src: '/应用中心/试卷（库）设置/试卷的启用_停用.mp4'
                    },
                    {
                        label: '填写试卷信息',
                        src: '/应用中心/试卷（库）设置/填写试卷信息.mp4'
                    },
                    {
                        label: '在线考试（练习）设置',
                        src: '/应用中心/试卷（库）设置/在线考试（练习）设置.mp4'
                    },
                ]
            },
            {
                label: '生成试卷（Word）',
                children: [
                    {
                        label: '生成试卷（Word）--学生卷',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--学生卷.mp4'
                    },
                    {
                        label: '生成试卷（Word）--选择题选项快速对齐',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--选择题选项快速对齐.mp4'
                    },
                    {
                        label: '生成试卷（Word）--选择题括号快速对齐',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--选择题括号快速对齐.mp4'
                    },
                    {
                        label: '生成试卷（Word）--普通卷：更换样式',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--普通卷：更换样式.mp4'
                    },
                    {
                        label: '生成试卷（Word）--普通卷',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--普通卷.mp4'
                    },
                    {
                        label: '生成试卷（Word）--快速设置版式',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--快速设置版式.mp4'
                    },
                    {
                        label: '生成试卷（Word）--教师卷',
                        src: '/应用中心/生成试卷（Word）/生成试卷（Word）--教师卷.mp4'
                    },
                ]
            },
            {
                label: '导出到幻灯片',
                children: [
                    {
                        label: '导出到幻灯片',
                        src: '/应用中心/导出到幻灯片/导出到幻灯片.mp4'
                    },
                ]
            },
        ]
    }
];


//云题库的视频目录
const cloudList = [
    {
        label: '网页版快速入门',
        src: '/网页版操作视频.mp4'
    },
    {
        label: '查看成绩',
        children: [
            {
                label: '按考生',
                children: [
                    {
                        label: '查看考生成绩',
                        src: '/查看成绩/查看成绩/按考生/查看考生成绩.mp4'
                    },
                    {
                        label: '查找考生',
                        src: '/查看成绩/查看成绩/按考生/查找考生.mp4'
                    },
                ]
            },
            {
                label: '按考试',
                children: [
                    {
                        label: '查看考试',
                        src: '/查看成绩/查看成绩/按考试/查看考试.mp4'
                    },
                    {
                        label: '查看考试成绩',
                        src: '/查看成绩/查看成绩/按考试/查看考试成绩.mp4'
                    },
                    {
                        label: '考试成绩作废，启用',
                        src: '/查看成绩/查看成绩/按考试/考试成绩作废，启用.mp4'
                    },
                ]
            }
        ]
    },
    {
        label: '查看解析',
        children: [
            {
                label: '类似题目',
                src: '/查看解析/类似题目.mp4'
            },
            {
                label: '设置试题篮',
                src: '/查看解析/设置试题篮.mp4'
            },
            {
                label: '相关试卷',
                src: '/查看解析/相关试卷.mp4'
            },
        ]
    },
    {
        label: '查看试卷（试卷库）',
        children: [
            {
                label: '编辑题目',
                src: '/查看试卷（试卷库）/编辑题目.mp4'
            },
            {
                label: '查看解析',
                src: '/查看试卷（试卷库）/查看解析.mp4'
            },
            {
                label: '纠错',
                src: '/查看试卷（试卷库）/纠错.mp4'
            },
            {
                label: '收藏',
                src: '/查看试卷（试卷库）/收藏.mp4'
            },
            {
                label: '添加或移除选题',
                src: '/查看试卷（试卷库）/添加或移除选题.mp4'
            },
            {
                label: '下载试卷',
                src: '/查看试卷（试卷库）/下载试卷.mp4'
            },
            {
                label: '选择或添加本页',
                src: '/查看试卷（试卷库）/选择或添加本页.mp4'
            },
        ]
    },
    {
        label: '答题卡',
        children: [
            {
                label: '答题卡',
                src: '/答题卡/答题卡.mp4'
            }
        ]
    },
    {
        label: '上传题目',
        children: [
            {
                label: '仅提交到题库',
                src: '/上传题目/仅提交到题库.mp4'
            },
            {
                label: '上传方式(2)',
                src: '/上传题目/上传方式(2).mp4'
            },
            {
                label: '上传前',
                src: '/上传题目/上传前.mp4'
            },
            {
                label: '上传前(2)',
                src: '/上传题目/上传前(2).mp4'
            },
            {
                label: '设置难度',
                src: '/上传题目/设置难度.mp4'
            },
            {
                label: '设置难度2',
                src: '/上传题目/设置难度2.mp4'
            },
            {
                label: '设置适用范围',
                src: '/上传题目/设置适用范围.mp4'
            },
            {
                label: '设置题类',
                src: '/上传题目/设置题类.mp4'
            },
            {
                label: '设置题型',
                src: '/上传题目/设置题型.mp4'
            },
            {
                label: '设置题型2',
                src: '/上传题目/设置题型2.mp4'
            },
            {
                label: '设置章节',
                src: '/上传题目/设置章节.mp4'
            },
            {
                label: '同时提交到试题库',
                src: '/上传题目/同时提交到试题库.mp4'
            },
            {
                label: '知识点',
                src: '/上传题目/知识点.mp4'
            },
        ]
    },
    {
        label: '试卷库',
        children: [
            {
                label: '查看试卷',
                src: '/试卷库/试卷库/试卷库/查看试卷.mp4'
            },
            {
                label: '发布考试',
                src: '/试卷库/试卷库/试卷库/发布考试.mp4'
            },
            {
                label: '启用停用',
                src: '/试卷库/试卷库/试卷库/启用停用.mp4'
            },
            {
                label: '下载试卷',
                src: '/试卷库/试卷库/试卷库/下载试卷.mp4'
            },
        ]
    },
    // {
    //     label: '考试管理',
    //     children: [
    //         {
    //             label: '编辑考试',
    //             src: '/考试管理/编辑考试.mp4'
    //         },
    //         {
    //             label: '启用与作废',
    //             src: '/考试管理/启用与作废.mp4'
    //         },
    //         {
    //             label: '搜索考试',
    //             src: '/考试管理/搜索考试.mp4'
    //         },
    //     ]
    // },
    {
        label: '手工组卷',
        children: [
            {
                label: '共享范围',
                src: '/手工组卷/共享范围.mp4'
            },
            {
                label: '共享范围(2)',
                src: '/手工组卷/共享范围(2).mp4'
            },
            {
                label: '上传试题篮',
                src: '/手工组卷/上传试题篮.mp4'
            },
            {
                label: '试题筛选',
                src: '/手工组卷/试题筛选.mp4'
            },
            {
                label: '选择教材版本',
                src: '/手工组卷/选择教材版本.mp4'
            },
            {
                label: '选择教材版本(2)',
                src: '/手工组卷/选择教材版本(2).mp4'
            },
            {
                label: '选择课本',
                src: '/手工组卷/选择课本.mp4'
            },
        ]
    },
    {
        label: '智能组卷',
        children: [
            {
                label: '试卷设置',
                src: '/智能组卷/试卷设置.mp4'
            },
            {
                label: '题型题量设置',
                src: '/智能组卷/题型题量设置.mp4'
            },
            {
                label: '选择章节',
                src: '/智能组卷/选择章节.mp4'
            },
        ]
    }
];


//在线考试视频目录
const examList = [
    {
        label: '上传即考试',
        src: `${path}video/exam/上传即考试.mp4`
    },
    {
        label: '在线考试 -- PC端',
        src: `${path}video/exam/在线考试pc端.mp4`
    },
    {
        label: '在线考试 -- 手机端',
        src: `${path}video/exam/在线考试手机端.mp4`
    },
    {
        label: '在线考试 -- 微信小程序',
        src: `${path}video/exam/微信小程序考试.mp4`
    },
    {
        label: '自动评分',
        src: `${path}video/exam/自动评分.mp4`
    },
    {
        label: '拍照上传',
        src: `${path}video/exam/拍照上传.mp4`
    },
];


//ppt视频目录
const pptList = [
    {
        label: '插入幻灯片',
        src: `${path}video/ppt/ppt插入幻灯片.mp4`
    },
    {
        label: '格式设置',
        src: `${path}video/ppt/ppt格式设置.mp4`
    },
    {
        label: '拼图',
        src: `${path}video/ppt/ppt拼图.mp4`
    },
    {
        label: '删除幻灯片',
        src: `${path}video/ppt/ppt删除幻灯片.mp4`
    },
    {
        label: '转换类型',
        src: `${path}video/ppt/ppt转换类型.mp4`
    },
    {
        label: 'ppt转图片或pdf',
        src: `${path}video/ppt/ppt转pdf.mp4`
    },
];


//word视频目录
const wordList = [
    {
        label: '超链接设置',
        src: `${path}video/word/超链接设置.mp4`
    },
    {
        label: '格式设置',
        src: `${path}video/word/格式设置.mp4`
    },
    {
        label: '内容批量替换',
        src: `${path}video/word/内容批量替换.mp4`
    },
    {
        label: '设置图片',
        src: `${path}video/word/设置图片.mp4`
    },
    {
        label: 'word页眉设置',
        src: `${path}video/word/word页眉设置.mp4`
    },
    {
        label: 'word转图片或pdf',
        src: `${path}video/word/word转pdf.mp4`
    },
];
export default {
    personalList,
    netList,
    cloudList,
    examList,
    pptList,
    wordList
};